import React, { useState, useEffect } from "react";
import { db } from "../../config/FirebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { FaLongArrowAltRight } from "react-icons/fa";
import { openSupportChat, HIRE_MESSAGE } from "../SupportChat/SupportChat";
import { IoMdClose } from "react-icons/io";
import "./FloatingNotification.css";
import { trackSocialClick } from "../../services/socialClicksService";

const FloatingNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [hasPlans, setHasPlans] = useState(false);
  const [notification, setNotification] = useState({
    title: "",
    subtitle: "",
    ctaText: "",
    isActive: true,
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const docRef = doc(db, "config", "notification");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setNotification({
            title: data.title || "",
            subtitle: data.subtitle || "",
            ctaText: data.ctaText || "",
            isActive: data.isActive !== undefined ? data.isActive : true,
          });
        }
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };

    fetchSettings();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const shouldBeVisible = window.scrollY > 600 && notification.isActive;
      if (shouldBeVisible !== isVisible) {
        setIsVisible(shouldBeVisible);
        // Os preços estão nos cards de #plans (só existem na home).
        setHasPlans(Boolean(document.getElementById("plans")));
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isVisible, notification.isActive]);

  const handleDismiss = () => {
    if (isClosing) return;
    setIsClosing(true);
    window.setTimeout(() => {
      setIsDismissed(true);
      localStorage.setItem("ctaDismissed", "true");
    }, 420);
  };

  if (isDismissed || !notification.isActive) return null;

  return (
    <div
      className={`floating-notification-container ${
        isVisible && !isClosing ? "visible" : ""
      } ${isClosing ? "closing" : ""}`}
    >
      <div className="floating-notification">
        <div className="notification-content">
          <span className="notification-subtitle">{notification.subtitle}</span>
          <span className="notification-title">{notification.title}</span>
        </div>

        <div className="notification-actions">
          {hasPlans && (
            <button
              type="button"
              className="plans-button"
              onClick={() => {
                trackSocialClick("floating_notification_plans");
                document
                  .getElementById("plans")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Ver planos
            </button>
          )}
          <button
            type="button"
            className="cta-button"
            onClick={() => {
              trackSocialClick("floating_notification");
              openSupportChat(HIRE_MESSAGE);
            }}
          >
            {notification.ctaText}
            <FaLongArrowAltRight className="cta-icon" />
          </button>
          <button
            className="close-button"
            onClick={handleDismiss}
            aria-label="Close notification"
          >
            <IoMdClose size={16} color="#f5f7ff" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FloatingNotification;
